<template>
  <kst-table paginated view-mode 
    :action="hasAccessAction"
    :data="dataList"
  >
    <b-table-column sortable 
      v-slot="{ column, row }"
      field="ExpenseNumber"
      :label="Catalog.ExpenseNumber.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column centered sortable 
      cell-class="ks-col-shortdate"
      v-slot="{ column, row }"
      field="Date"
      :label="Catalog.Date.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column sortable
      v-slot="{ column, row }"
      field="SubCategoryName"
      :label="Catalog.SubCategoryName.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column sortable 
      v-slot="{ column, row }"
      field="WarehouseID"
      :label="Catalog.WarehouseID.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column sortable 
      v-slot="{ column, row }"
      field="PaymentTypeName"
      :label="Catalog.PaymentTypeName.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column numeric sortable
      cell-class="ks-col-price has-text-weight-bold"
      v-slot="{ column, row }"
      field="Total"
      :label="Catalog.Total.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <template #action="{ row }">
      <Action :access="access" :row="row"/>
    </template>
  </kst-table>
</template>

<script>
import Catalog from "../ExpCatalog.js";
import Action from "./ExpL_List_Action.vue";

export default {
  components: {
    Action
  },
  props: {
    access: Object,
    dataList: Array
  },
  data: () => ({
    Catalog: Catalog
  }),
  computed: {
    hasAccessAction() {
      return this.access.Act_Details ||
        this.access.Act_Edit ||
        this.access.Act_ExportDetails;
    }
  }
}
</script>